import type { IUser } from '@models/IUser';
import type { IFieldElem } from '@models/IFormData';
import type { IVariables } from '@models/Forms/IForms';
import { VariablesManager } from '@utils/managers/VariablesManager';
import { errorText } from '@srm/core/errors';
import { sendModalMsg } from '@srm/ui/lib/modalMessages';

interface IComputeVariablesFieldParams {
    variables: IVariables;
    docId: string;
    user: IUser;
    fields: Record<string, IFieldElem>;
    isEdit: boolean;
    isNew: boolean;
    /** Результат ещё нужен: устаревшая инициализация (другой документ, новый запуск) ошибку не показывает. */
    isCurrent: () => boolean;
    /** Источник для лога. */
    source: string;
}

/**
 * Поле `variables` карты полей формы. Ошибка конфигурации переменных не мешает открыть форму:
 * она открывается без variables (`undefined`), причина показывается пользователю.
 */
export async function computeVariablesField({
    variables,
    docId,
    user,
    fields,
    isEdit,
    isNew,
    isCurrent,
    source,
}: IComputeVariablesFieldParams): Promise<IFieldElem | undefined> {
    try {
        const value = await new VariablesManager(variables, docId, user).GetData(fields, isEdit, isNew);
        return { name: 'variables', value, index: -1 };
    } catch (error) {
        console.error(`${source}: ошибка вычисления переменных`, error);
        if (isCurrent()) {
            sendModalMsg({ message: [`Не удалось вычислить переменные формы: ${errorText(error)}`], type: 'error' });
        }
        return undefined;
    }
}
